export enum ConversationDetailTabStatus {
  initial,
  loading,
  loaded,
}
